module.exports = __webpack_public_path__ + "static/media/Diglett_gaussian2.c9e1daff.png";